import React from "react";
import { Link } from "react-router-dom";
import { COLLECTIONS } from "../data";

const ShopBySegment = () => {
  return (
    <section id="segments" className="max-w-[1400px] mx-auto px-4 md:px-8 py-14 md:py-20">
      <h2 className="heading-font text-center text-3xl md:text-4xl mb-10 md:mb-14 tracking-wide">
        SHOP BY SEGMENT
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-4 gap-y-8">
        {COLLECTIONS.map((col) => (
          <Link key={col.slug} to={`/collections/${col.slug}`} className="group block">
            <div className="relative overflow-hidden bg-black aspect-square">
              <img
                src={col.image}
                alt={col.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
            </div>
            <p className="heading-font text-center mt-3 text-[#ED1C24] text-sm md:text-base tracking-wide group-hover:text-black transition-colors">
              {col.name}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default ShopBySegment;
